import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  grayContainer: {
    borderRadius: '5px',
    background: '#EBECF4',
    width: '100%',
    height: '100%',
    marginBottom: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
  },
  text: {
    textAlign: 'center',
    color: '#3C419A',
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '24px',
    margin: '30px',
    width: '492px',
  },
  icon: {
    color: '#BCBEDC',
    height: '65px',
    width: '65px',
    borderRadius: '0px',
  },
  button: {
    color: '#FFFFFF',
    fontWeight: 500,
    fontSize: '15px',
    lineHeight: '26px',
    backgroundColor: '#3C419A',
    '&:hover': {
      backgroundColor: '#2C307D',
    },
  },
}));
